<template>
  <div class="second-step">
    <FacilityDocuForm
        ref="form"
        @dialogClosed="() => { $emit('dialogClosed') }"
        hide-button
    />
  </div>
</template>

<script>
import FacilityDocuForm from '@/modules/book/views/facility/facility/formDialogs/form/FacilityDocuForm';

export default {
  name: 'CreateLocalDocumentationStep',
  components: {FacilityDocuForm},
  methods: {
    save() {
      this.$refs.form.uploadFacilityDocumentation();
    },
    setInputData(inputData) {
      this.$refs.form.uploadAsUrl(inputData.file);
      this.$refs.form.loadEnums();
      this.$refs.form.setFacilityId(inputData.facilityId);
    },
    cancelDialog() {
      this.$refs.form.clearForm();
    }
  }
}
</script>